import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';
import { CONSTS } from './const';
import { AxiosResponseModel } from '../../@types/base';
import {
  GetAllCompanies,
  GetAllFireFighters,
  UpdateCompanyRelation,
  FireCategoryResultModel, FireFighterNotificationModel
} from '../../@types/fireFighter';
import { HttpStatusCodes } from '../../constants/http-status-codes.enum';

// ----------------------------------------------------------------------

type FireFighterState = {
  fireFighterError: boolean;
  isFireFighterLoading: boolean;
  fireFighterNotification: FireFighterNotificationModel[];
  companies: GetAllCompanies[];
  updateCompanyFireFighterIsOpen: boolean;
};

const initialState: FireFighterState = {
  fireFighterError: false,
  isFireFighterLoading: false,
  fireFighterNotification: [],
  companies: [],
  updateCompanyFireFighterIsOpen: false
};

const slice = createSlice({
  name: 'fireFighter',
  initialState,
  reducers: {

    startFireFighterLoading(state) {
      state.isFireFighterLoading = true;
    },

    stopFireFighterLoading(state) {
      state.isFireFighterLoading = false;
      state.fireFighterError = false;
    },

    hasErrorFireFighter(state) {
      state.isFireFighterLoading = false;
      state.fireFighterError = true;
    },

    onToggleUpdateCompanyFireFighterOpenModal(state, action) {
      state.updateCompanyFireFighterIsOpen = action.payload;
    },

    setCompaniesFireFighter(state, action) {
      state.companies = action.payload;
    },

    addFireFighterNotificationData(state, action) {
      state.fireFighterNotification.push(action.payload);
    }

  }
});

// Reducer
export default slice.reducer;

export const {
  onToggleUpdateCompanyFireFighterOpenModal,
  setCompaniesFireFighter,
  addFireFighterNotificationData
} = slice.actions;


export async function updateCompanyRelation(data: UpdateCompanyRelation, companyId: number) {
  dispatch(slice.actions.startFireFighterLoading());
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.FIRE_FIGHTER_UPDATE_COMPANY}/${companyId}`, data)
      .catch((error) => {
        dispatch(slice.actions.hasErrorFireFighter(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopFireFighterLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }

    return response.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
  }
  return null;
}

export async function unsetCompanyOnFire(companyId: number) {
  dispatch(slice.actions.startFireFighterLoading());
  try {
    const response: AxiosResponseModel<null> = await axios
      .post(`${CONSTS.FIRE_FIGHTER_UNSET_COMPANY_ON_FIRE}/${companyId}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorFireFighter(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopFireFighterLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }
    return response.data;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
  }
  return null;
}


export async function getAllFireCategoriesWithReturn() {
  // dispatch(slice.actions.startFireCategoryListLoading());
  try {
    const response: AxiosResponseModel<FireCategoryResultModel> = await axios
      .get(CONSTS.CONSTANTS_GET_GET_ALL_FIRE_CATEGORIES)
      .catch((error) => {
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      // dispatch(slice.actions.getAllFireCategoriesSuccess(response.data?.data));
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }
    return response.data?.data;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
    return error.response.data;
  }
}

export async function getAllBurningCompanies() {
  dispatch(slice.actions.startFireFighterLoading());
  try {
    const response: AxiosResponseModel<GetAllCompanies[]> = await axios
      .get(`${CONSTS.FIRE_FIGHTER_GET_ALL_ON_FIRE_COMPANIES}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorFireFighter(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopFireFighterLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }
    return response.data?.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
  }
  return null;
}

export async function getAllCompaniesFireFighter() {
  dispatch(slice.actions.startFireFighterLoading());
  try {
    const response: AxiosResponseModel<GetAllCompanies[]> = await axios
      .get(`${CONSTS.FIRE_FIGHTER_GET_ALL_COMPANIES}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorFireFighter(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopFireFighterLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }
    dispatch(slice.actions.setCompaniesFireFighter(response.data?.data || []));
    return response.data?.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
  }
  return null;
}

export async function getAllFireFighters() {
  dispatch(slice.actions.startFireFighterLoading());
  try {
    const response: AxiosResponseModel<GetAllFireFighters[]> = await axios
      .get(`${CONSTS.FIRE_FIGHTER_GET_ALL_FIRE_FIGHTERS}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorFireFighter(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopFireFighterLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }
    return response.data?.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
  }
  return null;
}

export async function getFireFighterBase() {
  dispatch(slice.actions.startFireFighterLoading());
  try {
    const response: AxiosResponseModel<GetAllFireFighters> = await axios
      .get(`${CONSTS.FIRE_FIGHTER_GET_FIRE_FIGHTER_BASE}`)
      .catch((error) => {
        dispatch(slice.actions.hasErrorFireFighter(error));
        if (error.response) {
          return error.response.data;
        }
        return error;
      });
    if (response && response.status === HttpStatusCodes.StatusSuccess) {
      dispatch(
        slice.actions.stopFireFighterLoading()
      );
    } else {
      dispatch(slice.actions.hasErrorFireFighter());
    }
    return response.data?.data || null;
  } catch (error: any) {
    dispatch(slice.actions.hasErrorFireFighter(error));
  }
  return null;
}